import {
    useMemo,
} from 'react'

import APP_FLOW_STEPS from '@src/constants/FlowSteps'
import useFlowRouter from '@src/shared-components/FlowRouter/useFlowRouter'
import {
    ChatwootAppUser,
    useChatwootUser,
} from '@src/services/chatwoot'

function ChatwootUserSync(): null {
    const {
        currentStep,
        state,
    } = useFlowRouter()

    const user = useMemo<ChatwootAppUser | null>(() => {
        if (currentStep !== APP_FLOW_STEPS.accessDenied || !state.email || !state.gatewayMac) {
            return null
        }
        return {
            email: state.email,
            gatewayMac: state.gatewayMac,
        }
    }, [
        currentStep,
        state.email,
        state.gatewayMac,
    ])

    useChatwootUser(user)
    return null
}

export default ChatwootUserSync
